import React, { useState, forwardRef } from "react";
import { DialogTitle, DialogActions, Button, CircularProgress } from "@material-ui/core";

import DialogContent from "js/react/components/Dialogs/DialogContent";
import BeautifulDialog from "js/react/components/Dialogs/BeautifulDialog";

import log from "js/core/logger";

function SaveRecordingDialog({ closeDialog, uploadAndTranscodeAudio }, forwardedRef) {
    const [fetching, setFetching] = useState(false);
    const [uploadFailed, setUploadFailed] = useState(false);

    const handleSaveRecording = () => {
        setFetching(true);
        uploadAndTranscodeAudio()
            .then(() => {
                closeDialog(true);
            })
            .catch(err => {
                log.error(err);
                setFetching(false);
                setUploadFailed(true);
            });
    };

    return (
        <BeautifulDialog
            closeDialog={() => closeDialog(false)}
            preventClose
            ref={forwardedRef}
        >
            <DialogTitle>
                {!uploadFailed && "You have unsaved changes"}
                {uploadFailed && "Error"}
            </DialogTitle>
            <DialogContent>
                {!uploadFailed && "Would you like to add this recording to your slide?"}
                {uploadFailed && "Sorry, we were unable to process your recording, try again later."}
            </DialogContent>
            <DialogActions>
                {fetching &&
                    <CircularProgress
                        size={20}
                        style={{ marginRight: "50px", marginBottom: "8px", marginTop: "8px" }}
                    />
                }
                {!fetching &&
                    <>
                        <Button
                            onClick={() => closeDialog(false)}
                        >
                            Discard
                        </Button>
                        <Button
                            color="primary"
                            onClick={handleSaveRecording}
                            disabled={uploadFailed}
                        >
                            Add to slide
                        </Button>
                    </>
                }
            </DialogActions>
        </BeautifulDialog >
    );
}

export default forwardRef(SaveRecordingDialog);
